
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lookbook/category",
      function () {
        return require("private-next-pages/lookbook/category.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lookbook/category"])
      });
    }
  